import React, { useContext, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { OTTClient } from 'lib/jwtauth/ottClient'
import SessionRepository from 'domain/repository/session/SessionRepository'
import AccessToken from 'domain/entity/session/models/AccessToken'
import RefreshToken from 'domain/entity/session/models/RefreshToken'
import OAuthRepository from 'domain/repository/oauth/OAuthRepository'
import { LoadingSpinner } from 'presentation/shared/LoadingSpinner'
import { AppContext } from 'context'
import { OAuthAuthUrl } from 'const'

export default function OTTCallbackScreen() {
	const navigate = useNavigate()
	const { signIn } = useContext(AppContext)
	const handled = useRef(false)

	useEffect(() => {
		if (handled.current) return
		handled.current = true

		const params = new URLSearchParams(window.location.search)
		const ott = params.get('ott')

		if (!ott) {
			navigate('/login', { replace: true })
			return
		}

		const client = new OTTClient(OAuthAuthUrl)
		const sessionRepo = new SessionRepository()

		client
			.exchange(ott)
			.then(({ accessToken, refreshToken }) => {
				sessionRepo.saveAccessToken(new AccessToken(accessToken))
				sessionRepo.saveRefreshToken(new RefreshToken(refreshToken))
				OAuthRepository.markAsOAuthProvider()
				return signIn()
			})
			.then(() => {
				navigate('/', { replace: true })
			})
			.catch(err => {
				console.error('OTT callback error:', err)
				navigate('/login', { replace: true })
			})
	}, [])

	return (
		<div className='fixed inset-0 flex items-center justify-center'>
			<LoadingSpinner />
		</div>
	)
}
